module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.448c34a.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2
// module id = 267
// module chunks = 12